import { Layout } from '../../components/Layout';
import { PageFooter } from '../../components/PageFooter';
import { PageContent } from '../../components/PageContent';

import { TitleBlock } from '../../components/PageBlocks/TitleBlock';
import { SliderBlock } from '../../components/PageBlocks/SliderBlock';
import { NextPageBlock } from '../../components/PageBlocks/NextPageBlock';
import { MenuBlock } from '../../components/PageBlocks/MenuBlock';
import CookiesPopup from 'components/CookiesPopup';

import styles from './index.module.scss';

import Routes from '../../constants/Routes';
import { AboutBlock } from './sections/AboutBlock';
import { useWindowWidth } from 'hooks/useWindowWidth';

import { RootState } from 'store/store';
import { useSelector } from 'react-redux';

const pageData = {
	title: 'Ресторан',
	footer: {
		link: ['Забронировать столик', 'Задать вопрос по ресторану'],
		formTitle: 'Задать вопрос'
	},
	next: {
		name: 'Эспрессо бар',
		link: `${Routes.espresso_bar}`
	}
};

const RestaurantPage = () => {
	const windowWidth = useWindowWidth();

	const rest = useSelector((state: RootState) => state.data.data.rest);
	const menu = useSelector((state: RootState) => state.data.data);

	const menuData = {
		title: 'Меню',
		list: menu.config.rest
	};

	const aboutData = {
		title: 'О ресторане',
		main_info: rest.images['group-image'][1].description,
		img: [
			{
				href: rest.images['group-image'][1].original,
				alt: rest.images['group-image'][1].title
			},
			{
				href: rest.images['group-image'][0].original,
				alt: rest.images['group-image'][0].title
			}
		],
		info: rest.images['group-image'][0].description
	};

	return (
		<Layout className={styles.page}>
			<PageContent>
				<TitleBlock className={styles.page__title} type='h1'>
					{rest.name}
				</TitleBlock>
				<SliderBlock
					data={rest.images['group-slide']}
					className={styles.page__slider}
					convertColors
				/>
				<MenuBlock data={menuData} className={styles.page__menu} />
				<AboutBlock data={aboutData} />
				<NextPageBlock data={pageData.next} />
			</PageContent>
			{windowWidth && windowWidth > 1279 && (
				<PageFooter
					data={pageData.footer}
					className={styles.page__footer}
					formType={'red'}
				/>
			)}
			{!!menu.config.file_policy_1 && (
				<CookiesPopup link={menu.config.file_policy_1} />
			)}
		</Layout>
	);
};

export { RestaurantPage };
